import { CountertopMaterialData } from '../countertop-material/types';
import { RecordData } from '../../helpers-classes';
import { SurroundMaterialData } from '../surround-material/types';
import { KitchenMaterialData, KitchenMaterialDataIn } from './types';

export const kitchenMaterialData = (dataIn: KitchenMaterialDataIn = null): KitchenMaterialData => {
	const rd = new RecordData<KitchenMaterialDataIn>(dataIn);

	const record: KitchenMaterialData = {
		// corner: rd.useNewOrDefault<MaterialCornerData>('corner', {
		// 	key: 'stackedstone/graphite'
		// }),
		countertop: rd.useNewOrDefault<CountertopMaterialData>('countertop', null),
		surround: rd.useNewOrDefault<SurroundMaterialData>('surround', null)
	};

	return record;
};
